import React, { useEffect, useState } from 'react';
import { authenticateMagicLink } from '@general/api/memberAPI';
import { Redirect } from 'react-router-dom';
import Failure from './Failure';
import LogInLoading from '../LogInLoading';

const Authenticate = () => {
    const [params] = useState(new URLSearchParams(window.location.search.slice(1)));
    const [authError, setAuthError] = useState(false);
    const [stytchError] = useState(
        !params.has('stytch_token_type') || !['magic_links', 'login'].includes(params.get('stytch_token_type'))
    );

    useEffect(() => {
        if (stytchError) {
            return;
        }

        authenticateMagicLink(params.get('token'))
            .then(() => {
                window.location = params.get('returnUrl') ?? '/';
            })
            .catch(error => setAuthError(true));
    }, [stytchError, params, setAuthError]);

    if (stytchError) {
        return <Redirect to="/login" />;
    }

    if (authError) {
        return <Failure />;
    }

    return <LogInLoading />;
};

Authenticate.propTypes = {};

export default Authenticate;
